import {
  MainForms,
  AppTrackPage1,
  StaticPage1,
  LoginPage1,
  MapPage,
  ViewForm,
  Reports,
} from '../pages';
import AdminPage from 'pages/adminPanel';
import ForgotPassword from 'pages/login/forgotPassword'; //na ta grouparw otan teleiwsw - mhn ta kanw 1-1
import NewPasswordPage from 'pages/login/newPasswordPage';
import AuthErrorPage from 'pages/login/authErrorsPage';
import AlreadyLoggedPage from 'pages/login/alreadyLoggedInPage';
import FaqPage from 'pages/staticPages/faqPage';

export const routes = [
  {
    name: 'Admin',
    path: '/admin',
    Element: AdminPage,
  },
  {
    name: 'MainForms',
    path: '/main-forms/:taskId',
    Element: MainForms,
  },
  {
    name: 'MainForms',
    path: '/main-forms/:taskId/view',
    Element: MainForms,
  },
  {
    name: 'ApptrackView',
    path: '/appTrack/:taskId',
    Element: ViewForm,
  },
  {
    name: 'ApptrackView',
    path: '/appTrack/disabled/:taskId',
    Element: ViewForm,
  },
  {
    name: 'ApptrackView',
    path: '/appTrack/viewform',
    Element: ViewForm,
  },
  {
    name: 'ApptrackView',
    path: '/appTrack/viewform/disabled',
    Element: ViewForm,
  },
  {
    name: 'AppTrackPage1',
    path: 'appTrack',
    Element: AppTrackPage1,
  },
  {
    name: 'StaticPage1',
    path: '/',
    Element: StaticPage1,
  },
  {
    name: 'LoginPage1',
    path: 'login',
    Element: LoginPage1,
  },
  {
    name: 'ForgotPassword',
    path: '/forgot-password',
    Element: ForgotPassword,
  },
  {
    name: 'NewPassword',
    path: '/new-password',
    Element: NewPasswordPage,
  },
  {
    name: 'AuthError',
    path: '/auth-error',
    Element: AuthErrorPage,
  },
  {
    name: 'AlreadyLogged',
    path: '/already-logged',
    Element: AlreadyLoggedPage,
  },
  {
    name: 'MapPage',
    path: '/map',
    Element: MapPage,
  },
  {
    name: 'ReportsPage',
    path: '/reports',
    Element: Reports,
  },
  {
    name: 'FaqPage',
    path: '/faq',
    Element: FaqPage,
  },
];
